import "./Logo.scss";

export default function Logo() {
	return (
		<h1 className="logo">
			REY<span>ENGINE</span>
		</h1>
	);
}
